import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div class="max-width-frame svelte-3q2kj1npm4lxx"><!></div>`);

function MaxWidth($$anchor, $$props) {
	var div = root();
	var node = $.child(div);

	$.snippet(node, () => $$props.children);
	$.reset(div);
	$.append($$anchor, div);
}

if (import.meta.hot) {
	MaxWidth = $.hmr(MaxWidth);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3q2kj1npm4lxx');
		MaxWidth[$.HMR].update(module.default);
	});
}

export default MaxWidth;
import "bun-svelte:MaxWidth.svelte-11gyrk3nege8t-style.css";